"use client"

import { useState } from "react"
import SearchBar from "../components/SearchBar"
import SubjectFilter from "../components/SubjectFilter"
import MnemonicCard from "../components/MnemonicCard"
import { sampleMnemonics } from "../data/mnemonics"
import { Brain } from "lucide-react"

const HomePage = () => {
  const [activeFilter, setActiveFilter] = useState("all")
  const [searchTerm, setSearchTerm] = useState("")

  // Filter mnemonics based on active filter and search term
  const filteredMnemonics = sampleMnemonics.filter((mnemonic) => {
    const matchesFilter = activeFilter === "all" || mnemonic.subject.toLowerCase() === activeFilter
    const matchesSearch =
      searchTerm === "" ||
      mnemonic.concept.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mnemonic.chapter.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mnemonic.mnemonic.toLowerCase().includes(searchTerm.toLowerCase())

    return matchesFilter && matchesSearch
  })

  const handleSearch = (term) => {
    setSearchTerm(term)
  }

  return (
    <div className="container mx-auto px-4 py-8">
      {/* Hero Section */}
      <section className="text-center mb-12">
        <div className="flex justify-center mb-4">
          <div className="bg-gradient-to-r from-blue-500 via-green-500 to-orange-500 p-3 rounded-full">
            <Brain className="w-10 h-10 text-white" />
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-4">Master concepts with powerful mnemonics</h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          Simplify complex Physics, Chemistry, and Math concepts with easy-to-remember mnemonics .
        </p>
      </section>

      {/* Search Bar */}
      <section className="mb-10">
        <SearchBar onSearch={handleSearch} />
      </section>

      {/* Subject Filters */}
      <section className="mb-8">
        <SubjectFilter activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
      </section>

      {/* Mnemonics Grid */}
      <section>
        {filteredMnemonics.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredMnemonics.map((mnemonic) => (
              <MnemonicCard key={mnemonic.id} mnemonic={mnemonic} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">No mnemonics found. Try a different search term or filter.</p>
          </div>
        )}
      </section>
    </div>
  )
}

export default HomePage
